import { createSelector } from 'reselect';

// @ts-expect-error migrate upstream
import { selectAllGates } from './index';
import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
export const selectUserHasGates = (...gates) => createSelector(selectAllGates, gatesList => gates.every(g => gatesList.includes(g)));

// v3 gates aren't backed by redux, and are instead retrieved from the user-info package
// v3 gates will become the new norm https://product.hubteam.com/docs/gating/next-gen/overview.html
const selectUserHasV3Gate = gateId => {
  try {
    const {
      gates
    } = userInfoSync();
    return gates.includes(gateId);
  } catch (err) {
    return false;
  }
};
export const selectHasSalesExplorerExpGate = selectUserHasGates('RA:SalesExplorerExp');
export const selectHasSetBusinessUnitMigrationAccess = selectUserHasGates('RM:SetBusinessUnitMigration');
export const selectHasSetBusinessUnitDBUIMigrationAccess = selectUserHasGates('RM:SetBusinessUnitDBUIMigration');
export const selectHasCSATSurvey = selectUserHasGates('RM:CSATSurvey');
export const selectHasDashboardFiltersInSRV = () => selectUserHasV3Gate(gate('RM:DashboardFiltersInSRV'));
export const selectHasGranularPermissionsAccess = () => selectUserHasV3Gate(gate('Dashboards:GranularPermissionsGate'));
export const selectHasDataFirstFlowAccess = () => selectUserHasV3Gate(gate('ReportCreation:DataFirstCreationFlow'));
export const selectHasReportingInsightsCopilotAccess = () => selectUserHasV3Gate(gate('ReportingPlatform:ReportingInsightsCopilotTool'));
export const selectHasDashboardSRVTabsAccess = () => selectUserHasV3Gate(gate('ReportingEnablement:dashboardTabs'));
export const selectHasUnifiedFilterDashboard = () => selectUserHasV3Gate(gate('RM:UnifiedFilterDashboardUI'));
export const selectHasDashboardPanelAccess = () => selectUserHasV3Gate(gate('RH:DashboardCreationPanel'));
export const selectHasReportSetupAccess = () => selectUserHasV3Gate('Reporting:ReportSetup');